<div style="        margin: 1% 0%;
    
    padding: 18px 15px;
   
   background-color:white ;">
    <form class="example-form" [formGroup]="appForm" (ngSubmit)="onSubmit()">

        <table class="example-full-width" cellspacing="0">
            <tr>
                <td [attr.colspan]="isMobile ? 1 : 2"><mat-form-field class="example-full-width">
                        <mat-label>Title</mat-label>
                        <input matInput formControlName="title">
                        <mat-hint style="display:flex;justify-content: end; " align="end">{{
                            appForm.get('title')?.value?.length ||
                            0 }}/150</mat-hint>
                        <mat-error class="error label-color-error"
                            *ngIf="appForm.get('title')?.hasError('required')">Required</mat-error>
                        <mat-error
                            *ngIf="!appForm.get('title')?.hasError('maxLength') && appForm.get('title')?.value.length > titleMaxLength"
                            class="error label-color-error">
                            Maximum length is {{titleMaxLength}}
                            characters.
                            You entered {{appForm.get('title')?.value.length}} characters.
                        </mat-error>

                    </mat-form-field></td>
            </tr>
            <tr>
                <td [attr.colspan]="isMobile ? 1 : 2">
                    <label>Message *</label>
                    <angular-editor formControlName="htmlContent" class="border-bottom-error"
                        [config]="editorConfig"></angular-editor>
                    <mat-hint style="display:flex;justify-content: end; " align="end">{{
                        appForm.get('htmlContent')?.value?.length ||
                        0 }}/2000</mat-hint>
                    <mat-error class="error label-color-error"
                        *ngIf="appForm.get('htmlContent')?.hasError('required')">Required</mat-error>
                    <mat-error
                        *ngIf="!appForm.get('htmlContent')?.hasError('maxLength') && appForm.get('htmlContent')?.value.length > messageMaxLength"
                        class="error label-color-error">
                        Maximum length is {{messageMaxLength}}
                        characters.
                        You entered {{appForm.get('htmlContent')?.value.length}} characters.
                    </mat-error>
                    <br>
                </td>
            </tr>
            @if(isMobile){
            <tr>
                <td><mat-form-field class="example-full-width">
                        <mat-label>Select Audience</mat-label>
                        <mat-select formControlName="audience">
                            <mat-option [value]="audienceType.all">All</mat-option>
                            <mat-option [value]="audienceType.internal">{{audienceType.internal}}</mat-option>
                            <mat-option [value]="audienceType.external">{{audienceType.external}}</mat-option>
                        </mat-select>
                    </mat-form-field></td>
            </tr>
            <tr>
                <td><mat-form-field class="example-full-width">
                        <mat-label>Placement</mat-label>
                        <mat-select formControlName="placement">
                            <mat-option
                                [value]="notificationPlacement.login">{{notificationPlacement.login}}</mat-option>
                            <mat-option
                                [value]="notificationPlacement.dashboard">{{notificationPlacement.dashboard}}</mat-option>
                        </mat-select>
                    </mat-form-field></td>
            </tr>
            }
            @else {
            <tr>
                <td><mat-form-field class="example-full-width">
                        <mat-label>Select Audience</mat-label>
                        <mat-select formControlName="audience">
                            <mat-option [value]="audienceType.all">All</mat-option>
                            <mat-option [value]="audienceType.internal">{{audienceType.internal}}</mat-option>
                            <mat-option [value]="audienceType.external">{{audienceType.external}}</mat-option>
                        </mat-select>
                    </mat-form-field></td>
                <td><mat-form-field class="example-full-width">
                        <mat-label>Placement</mat-label>
                        <mat-select formControlName="placement">
                            <mat-option
                                [value]="notificationPlacement.login">{{notificationPlacement.login}}</mat-option>
                            <mat-option
                                [value]="notificationPlacement.dashboard">{{notificationPlacement.dashboard}}</mat-option>
                        </mat-select>
                    </mat-form-field></td>
            </tr>
            }
            <tr>
                <td [attr.colspan]="isMobile ? 1 : 2">
                    <div class="grid">
                        <!-- Date -->
                        <mat-form-field appearance="outline">
                            <mat-label>Start date</mat-label>
                            <input matInput [matDatepicker]="startDatePicker" formControlName="startDate"
                                [min]="startMinDate" [max]="max" placeholder="Choose date" />
                            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker startView="month"></mat-datepicker>
                        </mat-form-field>

                        <!-- Time -->
                        <mat-form-field appearance="outline">
                            <mat-label>Start time</mat-label>
                            <input matInput [matTimepicker]="startTimePicker" [max]="maxStartTime"
                                formControlName="startTime" [disabled]="!appForm.get('startDate')!.value">
                            <mat-timepicker-toggle matIconSuffix [for]="startTimePicker"></mat-timepicker-toggle>
                            <mat-timepicker #startTimePicker></mat-timepicker>

                            <mat-error class="error label-color-error" *ngIf="appForm.hasError('endNotAfterStart')">
                                End time must be strictly after Start time.
                            </mat-error>

                        </mat-form-field>
                    </div>
                </td>
            </tr>


            <tr>
                <td [attr.colspan]="isMobile ? 1 : 2">
                    <div class="grid">
                        <!-- Date -->
                        <mat-form-field appearance="outline">
                            <mat-label>End date</mat-label>
                            <input matInput [matDatepicker]="endDatePicker" formControlName="endDate" [min]="endMinDate"
                                [max]="max" placeholder="Choose date" />
                            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #endDatePicker startView="month"></mat-datepicker>
                            <!-- <mat-error *ngIf="eventDateTime.hasError('required')">Date & time are required</mat-error> -->
                        </mat-form-field>

                        <!-- Time -->
                        <mat-form-field appearance="outline">
                            <mat-label>End time</mat-label>
                            <input matInput [matTimepicker]="endTimepicker" formControlName="endTime"
                                [min]="appForm.get('startTime')?.value" [disabled]="!appForm.get('startTime')!.value">
                            <mat-timepicker-toggle matIconSuffix [for]="endTimepicker"></mat-timepicker-toggle>
                            <mat-timepicker #endTimepicker></mat-timepicker>
                        </mat-form-field>
                        <mat-error class="error label-color-error" style="padding: 0px 11px; padding-bottom: 10px;"
                            *ngIf="appForm.hasError('endNotAfterStart')">
                            End time must be strictly after Start time.
                        </mat-error>
                    </div>
                </td>
            </tr>
            <tr>
                <td [attr.colspan]="isMobile ? 1 : 2"><mat-form-field class="example-full-width">
                        <mat-label>Priority</mat-label>
                        <mat-select formControlName="priority">
                            <mat-option [value]="priorityEnum.Info" selected>Info</mat-option>
                            <mat-option [value]="priorityEnum.Warning">Warning</mat-option>
                            <mat-option [value]="priorityEnum.Critical">Critical</mat-option>
                        </mat-select>
                    </mat-form-field></td>
            </tr>


        </table>

        <div style="display: flex;
    justify-content: end;
    padding: 0% 1%;
    margin-top: 16%;">
            <button matButton="filled" mat-raised-button color="primary" class="cp-btn-submit" type="submit"
                [disabled]="!this.appForm.valid">Save</button>
            <button mat-raised-button color="Secondary" class="cp-btn-cancel" (click)="onCancel()">Cancel</button>
        </div>
    </form>
</div>